import { render } from "./Gameboard_SidePanel_Supplier.vue?vue&type=template&id=3facf15c"
import script from "./Gameboard_SidePanel_Supplier.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanel_Supplier.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanel_Supplier.vue?vue&type=style&index=0&id=3facf15c&lang=scss"
script.render = render

export default script